<div class="page-body-content">
  <ng-content></ng-content>
</div>
